import { Component, OnInit } from '@angular/core';
import { Title } from "@angular/platform-browser";
import { AuthenticationService } from '@app/services/authentication.service';
import { GlobalService } from '@app/services/global.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { map, filter, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})

export class AppComponent implements OnInit {
  title = 'Portal - Scs';
  currentUser: any;
  isLoggedIn: any = false;
  menuLink = [
    {
      title: "Contratos",
      routerLink: "/loans",
      icon: "file-alt"
    },
    {
      title: "Perfil",
      routerLink: "/admin",
      icon: "file-alt"
    }
  ]
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public  global: GlobalService
  ) {
    this.authenticationService.currentUser.subscribe((x) => {
      this.currentUser = x;
      if (this.currentUser != null) {
        this.isLoggedIn = true;
      }
    });
  }
  ngOnInit() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.activatedRoute.firstChild;
        while (child) {
          if (child.firstChild) {
            child = child.firstChild;
          } else if (child.snapshot.data && child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          } else {
            return null;
          }
        }
        return null;
      })).subscribe((title: any) => {
        this.titleService.setTitle(title);
      });
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/sessions/login']);
  }
}
